import { Injectable } from '@angular/core';
import { Incompatibilities } from '../Incompatibilities';
import { Gabinete } from '../model/Gabinete';
import { Mother } from '../model/Mother';
import { FuncionCompatilibidadBase } from './FuncionesCompatibilidadBase';
import { IncompatibilitiesType } from '@core/enums/incompatibilities-types.enum';

@Injectable({
  providedIn: 'root',
})
export class FC_MotherGabinete extends FuncionCompatilibidadBase<Mother, Gabinete> {
  funciones = {
    factor: (mother: Mother, gabinete: Gabinete): Incompatibilities | null => {
      return (
          !gabinete.$caracteristicas.tipo_mother.split(',').includes(mother.$caracteristicas.Factor)
        ) ?
          {
            tipo: IncompatibilitiesType.PRODUCTO,
            incompatibility: 'El gabinete no es compatible con el mother',
          }
        : null;
    },
    slot_memoria14375: (mother: Mother, gabinete: Gabinete): Incompatibilities | null => {
      if (
        gabinete.id_producto == 14375 &&
        mother.$caracteristicas.Factor.includes('M-ATX') &&
        mother?.$caracteristicas.slot_memoria == 4
      ) {
        return {
          tipo: IncompatibilitiesType.PRODUCTO,
          incompatibility: 'El gabinete no es compatible con la mother por los slot de memoria ram',
        };
      } else {
        return null;
      }
    },
    back_connect: (mother: Mother, gabinete: Gabinete): Incompatibilities | null => {
      let gBackConnect = gabinete.$caracteristicas.back_connect || 0;
      let mBackConnect = mother.$caracteristicas.back_connect || 0;
      if (mBackConnect == 1 && gBackConnect == 0) {
        return {
          tipo: IncompatibilitiesType.PRODUCTO,
          incompatibility: `El gabinete no admite Back-Connect`,
        };
      }
      return null;
    },
  };
}
